const login = resolve => require(['@/components/login'], resolve);
const transInfo = resolve => require(['@/components/moudle/transInfo'], resolve);
export default [
  {name: '/', path: '/', redirect: '/login'},
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/transInfo',
    name: 'transInfo',
    component: transInfo,
    meta:{requireAuth:true}
  },
  {path: '*', redirect: '/login'}
]



// WEBPACK FOOTER //
// ./src/router/index.js